import { createContext, useContext, useState, ReactNode } from 'react';

export interface RateLimitInfo {
  isRateLimit: boolean;
  isBankRateLimit: boolean;
  message: string;
  waitTimeHours?: number;
  waitTimeSeconds?: number;
  timestamp: number;
}

interface RateLimitContextType {
  rateLimitInfo: RateLimitInfo | null;
  setRateLimitInfo: (info: RateLimitInfo | null) => void;
  clearRateLimitInfo: () => void;
}

const RateLimitContext = createContext<RateLimitContextType | undefined>(
  undefined
);

export function RateLimitProvider({ children }: { children: ReactNode }) {
  const [rateLimitInfo, setRateLimitInfoState] = useState<RateLimitInfo | null>(
    null
  );

  const setRateLimitInfo = (info: RateLimitInfo | null) => {
    if (info) {
      setRateLimitInfoState({
        ...info,
        timestamp: Date.now(),
      });
    } else {
      setRateLimitInfoState(null);
    }
  };

  const clearRateLimitInfo = () => {
    setRateLimitInfoState(null);
  };

  return (
    <RateLimitContext.Provider
      value={{ rateLimitInfo, setRateLimitInfo, clearRateLimitInfo }}
    >
      {children}
    </RateLimitContext.Provider>
  );
}

export function useRateLimit() {
  const context = useContext(RateLimitContext);
  if (context === undefined) {
    throw new Error('useRateLimit must be used within a RateLimitProvider');
  }
  return context;
}
